module.exports = __webpack_public_path__ + "img/Stage_5_Diff.35001bfb.jpg";